import * as React from 'react'
import { Snackbar } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

export default function Message({
  id,
  message,
  open,
  handleClose,
  type,
  options = {},
}) {
  const messageId = `message-${id}`
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      autoHideDuration={6000}
      open={open}
      // autoHideDuration={4000}
      onClose={handleClose}
      {...options}
    >
      <Alert
        icon={false}
        variant="filled"
        onClose={handleClose}
        severity={type}
      >
        <span id={messageId}>{message}</span>
      </Alert>
    </Snackbar>
  )
}
